import { useFormContext, useWatch } from "react-hook-form";
import { FormSection, CopyRecordButton } from "@duosoftbg/nacid-components";
import { ReceiverAddressFormFields } from "@duosoftbg/nacid-frontoffice-components";
import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { countriesDataThunk } from "../../../../../../store/redux/slice/AppData/countriesData";
import { getSettlement, getSettlementsAutocomplete } from "../../../../../../axios/api/services";

const ReceiverAddressFormSection = () => {
  const { getValues, setValue } = useFormContext();

  const thunkStateCountries = useAppSelector((state) => {
    return state.AppData.countriesData;
  });

  const documentRecipient = useWatch({ name: "resultReceive.documentRecipient" });

  const onClick = () => {
    setValue("receiverAddress.city", getValues().contactAddress.city);
    setValue("receiverAddress.settlement", getValues().contactAddress.settlement);
    setValue("receiverAddress.country", getValues().contactAddress.country);
    setValue("receiverAddress.address", getValues().contactAddress.address);
    setValue("receiverAddress.postCode", getValues().contactAddress.postCode);
    setValue("receiverAddress.phone", getValues().contactAddress.phone);
  };

  if (documentRecipient) {
    return (
      <FormSection label={"t.receiverAddress.details.default"}>
        <ReceiverAddressFormFields
          requiredFormFields={false}
          actionButtonComponent={
            <CopyRecordButton
              labelCode={"l.copy.from.contact.address"}
              onClick={onClick}
              mr={0}
              mt={0}
              align={"right"}
            />
          }
          countriesThunk={countriesDataThunk}
          countriesThunkState={thunkStateCountries}
          getSettlementsAutocomplete={getSettlementsAutocomplete}
          getSettlement={getSettlement}
        />
      </FormSection>
    );
  } else {
    return null;
  }
};

export default ReceiverAddressFormSection;
